module.exports = __webpack_public_path__ + "img/user_square.82237887.png";